/**
 * StatisticListContainer
 * --
 */
import React from 'react';
import StatisticListPresenter from './StatisticListPresenter';

const StatisticListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <StatisticListPresenter />
    </>
  );
};

export default StatisticListContainer;
